import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const SomethingWentWrongDialog = (props) => (
    <Dialog
        id="something-went-wrong-dialog"
        disableBackdropClick
        disableEscapeKeyDown
        open={props.open}
    >
        <DialogTitle>
            Something Went Wrong!
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                Please try again later.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                id="logout-dismiss-button"
                onClick={props.onLogOutClick}
            >
                Log Out
            </Button>
            <Button
                id="something-went-wrong-dismiss-button"
                onClick={props.onReloadClick}
                color="secondary"
            >
                Reload
            </Button>
        </DialogActions>
    </Dialog>
);

SomethingWentWrongDialog.propTypes = {
    open: PropTypes.bool,
    onReloadClick: PropTypes.func,
    onLogOutClick: PropTypes.func,
};

SomethingWentWrongDialog.defaultProps = {
    open: true,
    onReloadClick: () => {},
    onLogOutClick: () => {},
};

export default SomethingWentWrongDialog;
